var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReviewLabReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.021 25h17.443c.572 0 1.021-.45 1.021-1.021V1.02c0-.572-.45-1.021-1.02-1.021H1.02C.45 0 0 .45 0 1.021V23.98C0 24.55.45 25 1.021 25ZM2.042 2.042h15.36v20.875H2.042V2.042Z",
    fill: "#2FAEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.99 5.27H6.495c-.572 0-1.021.449-1.021 1.02v4.045c0 .572.449 1.021 1.02 1.021h6.496c.572 0 1.021-.45 1.021-1.021V6.29c0-.572-.45-1.021-1.021-1.021Zm-1.021 4.044H7.516V7.353h4.453v1.96ZM12.99 13.44H6.495c-.572 0-1.021.449-1.021 1.02 0 .573.449 1.022 1.02 1.022h6.496c.572 0 1.021-.45 1.021-1.021 0-.572-.45-1.021-1.021-1.021ZM12.99 17.606H6.495c-.572 0-1.021.45-1.021 1.021 0 .572.449 1.022 1.02 1.022h6.496c.572 0 1.021-.45 1.021-1.022 0-.572-.45-1.02-1.021-1.02Z",
    fill: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewLabReport);
export default __webpack_public_path__ + "static/media/icon_review_lab_report.05a36548a06ad5439a0b91153ed7a5f3.svg";
export { ForwardRef as ReactComponent };